export default __webpack_public_path__ + "static/media/22.bba3eb7e.png";